import { render, staticRenderFns } from "./OrderProfit.vue?vue&type=template&id=0fd1a438&scoped=true&"
import script from "./OrderProfit.vue?vue&type=script&lang=js&"
export * from "./OrderProfit.vue?vue&type=script&lang=js&"
import style0 from "./OrderProfit.vue?vue&type=style&index=0&id=0fd1a438&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd1a438",
  null
  
)

export default component.exports